// List provided by Hive Fountations team
// @see https://docs.google.com/document/d/1PI6ZbP6OVhEWdvqu2H5eeMsLswumehitJydCWLz9U-Q/edit?disco=AAABBO3_K3Q
// @see https://github.bumble.dev/services/bff_community/blob/master/bff-community/src/main/kotlin/com/bumble/community/communities/Community.kt

// Cosmos icons
// @see http://cosmos/bumble-mobile/components/assets/assets-srv?product=maya&platform=mw&theme=default&search=emoji

export enum CATEGORIES {
  CUSTOM = 0, // "speach-bubble"
  COFFEE = 1, // "soda"
  PIZZA = 2, // "pizza"
  OUTDOORS = 3, // "flower"
  NIGHTOUT = 4, // "mirror-ball"
  CHESS = 5, // "chess"
  SPORTS = 6, // "sneaker"
  CULTURE = 7, // "camera"
  TRAVEL = 8, // "air-plane"
  KIDS = 9, // "teddy-bear"
  FRIENDSGIVING = 10, // "turkey"
  HOLIDAY = 11, // "holiday"
  PALENTINES = 12, // "palentine-day"
}
